import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Funciona si estoy amamantando?',
    a: 'Sí. El kit es 100% compatible con la lactancia. Hay protocolos específicos para desacoplar el pecho de la asociación de sueño sin interrumpir la lactancia.'
  }, {
    q: '¿Funciona si mi bebé es prematuro?',
    a: 'Sí. El Tomo 4 está diseñado exclusivamente para bebés prematuros con todas las referencias en edad corregida.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'En menos de 5 minutos después del pago recibís el enlace de descarga por email. Funciona en celular, tablet o computadora.'
  }, {
    q: '¿Tiene garantía real?',
    a: '7 días completos. Si no es lo que esperabas, devolvemos el 100% sin preguntas.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto" data-id="element-103">
      <div className="text-center mb-12" data-id="element-104">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold text-white" data-id="element-105">
          LO QUE MÁS NOS PREGUNTAN
        </motion.h2>
      </div>

      <div className="space-y-4" data-id="element-106">
        {faqs.map((faq, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className="border border-navy-600 bg-navy-800/50 rounded-2xl overflow-hidden" data-id="element-107">
            <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-108">
              <span className="font-semibold text-white text-lg pr-8" data-id="element-109">
                {faq.q}
              </span>
              <ChevronDown className={`w-5 h-5 text-gold-400 transform transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-110" />
            </button>
            <AnimatePresence data-id="element-111">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-112">
                  <div className="px-6 pb-5 text-blue-100/80 leading-relaxed border-t border-navy-700/50 pt-4" data-id="element-113">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </motion.div>)}
      </div>
    </section>;
}